import { useEffect, useState } from "react";
import Seo from "../components/Seo";
import HeroSection from "../components/HeroSection";
import AnnouncementBanner from "../components/AnnouncementBanner";
import PurposeSection, { type StatsVariant } from "../components/PurposeSection";
import TestimonialsSection from "../components/TestimonialsSection";
import ExperiencesSection from "../components/ExperiencesSection";
import ApplyBanner from "../components/ApplyBanner";
import FinAidPopup from "../components/FinAidPopup";

/** Staging previews for marketing (Oct 25): /?stats=four shows By the Numbers as four flip
 *  cards, /?stats=one as a single flipping card, both inside Our Purpose with condensed copy.
 *  No param = the original layout. Read on the client only, so the prerender is the default. */
const statsVariant = (): StatsVariant => {
  const v = new URLSearchParams(window.location.search).get("stats");
  return v === "four" || v === "one" ? v : "none";
};

const Home = () => {
  const [stats, setStats] = useState<StatsVariant>("none");
  useEffect(() => setStats(statsVariant()), []);
  return (
  <>
    <Seo
      title="Youth Humanitarian Trips for Teens 14–19 | HXP"
      description="The hardest and best summer of your life. HXP leads youth humanitarian trips for teens ages 14–19 — two-week service expeditions to 73 locations in 40 countries. 48,000+ Builders since 1999."
      path="/"
    />
    <HeroSection />
    <AnnouncementBanner />
    <PurposeSection stats={stats} />
    <ExperiencesSection />
    <TestimonialsSection />
    <ApplyBanner />
    <FinAidPopup />
  </>
  );
};

export default Home;
